import Const from 'constants';
import {getTeamNamesOfGames} from 'helpers/game-helper';
import {getPlayerService} from 'services/sports/factory';
import {getFirstSportForModeAndSite} from 'helpers/sport-config';

let Settings = {
    setPlayerPositionsFilter(position) {
        return {
            type: Const.SET_PLAYER_POSITIONS_FILTER,
            position,
        };
    },
    resetLineupPlayerFilter() {
        return {
            type: Const.RESET_LINEUP_PLAYER_FILTER,
        };
    },
    resetLineupsFilters(filters) {
        return (dispatch) => {
            dispatch({
                type: Const.RESET_LINEUPS_FILTERS,
                data: filters,
            });

            dispatch(this.setPlayersCounters());
        };
    },
    setModeFilter(mode) {
        return (dispatch, getSate) => {
            const {sportConfig} = getSate();

            if (sportConfig.getMode() === mode) {
                return;
            }

            dispatch(this.unsubscribeFromSlateLiveUpdates(sportConfig.getSlateId()));

            dispatch({
                type: Const.FILTER_BY_MODE,
                mode,
            });

            dispatch(this.unsetSlates());
            dispatch(this.unsetPlayers());
            dispatch(this.unsetLineups());

            dispatch(this.saveFiltersToStorage());
        };
    },
    setSiteFilter(site) {
        return (dispatch, getSate) => {
            const {sportConfig} = getSate();

            if (sportConfig.hasSite() && sportConfig.getSite() === site) {
                return;
            }

            const sport = getFirstSportForModeAndSite(sportConfig, sportConfig.getMode(), site);

            dispatch(this.unsubscribeFromSlateLiveUpdates(sportConfig.getSlateId()));

            dispatch({
                type: Const.FILTER_BY_SITE,
                site,
                sport,
            });

            dispatch(this.unsetSlates());
            dispatch(this.unsetPlayers());
            dispatch(this.unsetLineups());

            sport && dispatch(this.getSportConfig(sport, site, Const.GAME_TYPE_CLASSIC, sportConfig.getMode()));

            dispatch(this.saveFiltersToStorage());
        };
    },
    setSportFilter(sport) {
        return (dispatch, getSate) => {
            const {sportConfig} = getSate();

            if (sportConfig.hasSport() && sportConfig.getSport() === sport) {
                return;
            }

            dispatch(this.unsubscribeFromSlateLiveUpdates(sportConfig.getSlateId()));
            dispatch({
                type: Const.FILTER_BY_SPORT,
                site: sportConfig.getSite(),
                sport,
            });
            dispatch(this.unsetSlates());
            dispatch(this.unsetPlayers());
            dispatch(this.unsetLineups());
            dispatch(this.getSportConfig(sport, sportConfig.getSite(), Const.GAME_TYPE_CLASSIC, sportConfig.getMode()));
            dispatch(this.saveFiltersToStorage());
        };
    },
    setGameTypeFilter(gameType) {
        return (dispatch, getSate) => {
            const {sportConfig} = getSate();

            if (sportConfig.hasGameType() && sportConfig.getGameType() === gameType) {
                return;
            }

            dispatch(this.unsubscribeFromSlateLiveUpdates(sportConfig.getSlateId()));
            dispatch({
                type: Const.FILTER_BY_GAME_TYPE,
                gameType,
            });
            dispatch(this.unsetSlates());
            dispatch(this.unsetPlayers());
            dispatch(this.unsetLineups());
            dispatch(
                this.getSportConfig(sportConfig.getSport(), sportConfig.getSite(), gameType, sportConfig.getMode()),
            );

            if (!sportConfig.isModeLateswap()) {
                dispatch(this.getSlates(sportConfig.getSite(), sportConfig.getSport(), gameType));
            }
        };
    },
    setSlateFilter(slateId) {
        return (dispatch, getSate) => {
            const {sportConfig} = getSate();

            if (!sportConfig.hasSite() || !sportConfig.hasSport() || sportConfig.isSlateIdEqual(slateId)) {
                return;
            }

            dispatch({
                type: Const.FILTER_BY_SLATE,
                slateId,
            });
            dispatch({type: Const.HIDE_DROPZONE});
            dispatch(this.subscribeToSlateLiveUpdates(slateId));
            dispatch({
                type: Const.SET_DEFAULT_VALUES_FOR_LINEUPS_FILTERS,
            });
            dispatch(this.unsetPlayers());
            dispatch(this.unsetLineups());
            // dispatch(this.resetFlexMaxExposurePositions());
            // dispatch(this.resetSuperFlexMaxExposurePositions());
            dispatch(this.setPlayersCounters());
            dispatch(this.getSlate(slateId, sportConfig.getSport()));
            dispatch(this.saveFiltersToStorage());
        };
    },
    setGamesFilterIfNecessary(games = [], saveFilters = true) {
        return (dispatch, getState) => {
            const {
                playersData: {filters},
                sportConfig,
            } = getState();

            if (filters.games.length <= 0 || sportConfig.isModeLateswap()) {
                const teamNames = getTeamNamesOfGames(games);
                dispatch(this.setGamesFilter(teamNames, saveFilters));
            }
        };
    },
    setGamesFilter(games = [], options = {}) {
        return (dispatch) => {
            const {saveFilters = true, countPlayers = true} = options;

            dispatch({
                type: Const.SET_GAMES_FILTER,
                data: games,
            });

            countPlayers && dispatch(this.setPlayersCounters());
            saveFilters && dispatch(this.saveFiltersToStorage('selectedGames'));
        };
    },
    filterByPlayersType(playersType) {
        return {
            type: Const.FILTER_BY_PLAYERS_TYPE,
            playersType,
        };
    },
    filterByPlayerName(name) {
        return {
            type: Const.FILTER_BY_PLAYER_NAME,
            name,
        };
    },
    filterByTeam(team) {
        return {
            type: Const.FILTER_BY_TEAM,
            team,
        };
    },
    stackCaptainToConstructor(value) {
        return {
            type: Const.F1_STACK_CAPTAIN_TO_CONSTRUCTOR,
            stackCaptainToConstructor: Boolean(value),
        };
    },
    setAllowOpposingTeamsInLineup(isAllowed) {
        return {
            type: Const.SET_ALLOW_OPPOSING_TEAMS_IN_LINEUP,
            allowOpposingTeamsInLineup: isAllowed,
        };
    },
    setPlayersSortBy(sort) {
        return {
            type: Const.SET_PLAYERS_SORT_BY,
            sort,
        };
    },
    setSortLineups(sort) {
        return {
            type: Const.LINEUPS_LIST_SET_SORT,
            sort,
        };
    },
    setRandomPoints(lineupNumber, points) {
        return {
            type: Const.SET_RANDOM_POINTS,
            lineupNumber,
            points,
        };
    },
    setUserLineGroups(lineGroupPoints) {
        return {
            type: Const.SET_PLAYERS_LINE_GROUP,
            data: lineGroupPoints,
        };
    },
    setUserPPLine(ppLinePoints) {
        return {
            type: Const.SET_PLAYERS_PP_LINE,
            data: ppLinePoints,
        };
    },
    unsetRandomPoints() {
        return {
            type: Const.UNSET_RANDOM_POINTS,
        };
    },
    resetSettings() {
        return (dispatch, getState) => {
            const {
                sportConfig,
                playersData: {games},
            } = getState();

            dispatch({
                type: Const.RESET_ALL_SETTINGS,
            });

            dispatch(
                this.setGamesFilter(getTeamNamesOfGames(games.getAllAsArr()), {
                    countPlayers: false,
                    saveFilters: false,
                }),
            );

            getPlayerService(sportConfig).exec('resetSettings', {dispatch});

            dispatch(this.setPointsBoundary());
            dispatch(this.setSalaryBoundary());
            dispatch(this.setPlayersCounters());
            dispatch(this.clearDataInStorage());
        };
    },
    checkAllLineups(checked) {
        return {
            type: Const.LINEUPS_LIST_SET_IS_CHECKED,
            checked,
        };
    },
    showUnexposedPlayers(checked) {
        return {
            type: Const.SHOW_UNEXPOSED_PLAYERS_IN_EXPOSURE_BOX,
            checked,
        };
    },
    setPoolsOfPlayers(pools) {
        return {
            type: Const.SET_PREPARED_PLAYERS_LIST,
            data: pools,
        };
    },
    setTeamDetails(teamDetails) {
        return {
            type: Const.SET_TEAM_DETAILS,
            data: teamDetails,
        };
    },
    unsetTeamDetails() {
        return {
            type: Const.UNSET_TEAM_DETAILS,
        };
    },
    applyTeams(teams) {
        const data = {};
        teams.map((team) => (data[team.teamAbbr] = {logo: team.logo}));

        return {
            type: Const.SET_TEAMS,
            data,
        };
    },
};

export default Settings;
